import { ManagerDictionariesType } from './filter-formatters/types';

// dictionaries received not from dashboard endpoint
export const managerDictionariesNames = [
  'salesManager' as const,
  'retentionManager' as const,
  'vipManager' as const,
  'closerManager' as const,
];

export const dictionariesNames = [
  ...managerDictionariesNames,
  'timeZone' as const,
];

export const dictionariesNamesToManagerKeysMap: {
  [K in typeof managerDictionariesNames[number]]: keyof ManagerDictionariesType;
} = {
  salesManager: 'conversionAgent',
  retentionManager: 'retentionManager',
  vipManager: 'vipManager',
  closerManager: 'closerManager',
};

export const DEFAULT_GRID_ROWS_NUMBER = [50];

export const customFilters = [
  {
    field: 'email',
    type: 'String',
    displayName: 'Email',
    isDefaultFilter: false,
    isHidden: undefined,
    conditions: {
      equalsTo: {
        name: 'Equals To',
        hasValue: true,
      },
      in: {
        name: 'In',
        hasValue: true,
      },
    },
  },
];
